<template>
  <MyManage>
    <el-tabs v-model="activeName" type="border-card" @tab-click="carTableClick">
      <el-tab-pane label="车辆管理" name="carList" v-if="checkPermission(['bee:res:car:getCars'])">

          <CarPage v-if="activeName=='carList'"></CarPage>

      </el-tab-pane>

      <!-- <el-tab-pane label="车型管理" name="modelList" v-if="checkPermission(['bee:res:model:getModels'])">

          <ModelPage v-if="activeName=='modelList'"></ModelPage>

      </el-tab-pane>

      <el-tab-pane label="车辆品牌管理" name="brandList" v-if="checkPermission(['bee:res:brand:getBrands'])">

          <BrandPage v-if="activeName=='brandList'"></BrandPage>

      </el-tab-pane> -->
    </el-tabs>
  </MyManage>
</template>

<script>
    import MyManage from '@/components/MyManage'
    import CarPage from '@/module/resourceCenter/page/car/carList/list.vue'
    import ModelPage from '@/module/resourceCenter/page/car/model/list.vue'
    import BrandPage from '@/module/resourceCenter/page/car/brand/list.vue'
    import Pagination from "../../../../components/Pagination";

    export default {
        name: "carManage",
        components: {
            MyManage,
            CarPage,
            ModelPage,
            BrandPage,
            Pagination
        },
        data() {

            return {
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                addBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                addBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'carList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'carList'
            }
        },

        created() {

        },
        mounted() {
            // this.submitCarSearchForm()
        },
        watch: {},
        methods: {
            carTableClick(tab, event) {
                console.log(tab, event)
                // if(tab.name == 'carList'){
                //     // 触发‘配置管理’事件
                //     this.pageparm.currentPage =1;
                //     this.submitCarSearchForm();
                // }
                // if(tab.name == 'modelList'){
                //     // 触发‘配置管理’事件
                //     this.pageparm.currentPage =1;
                //     this.submitModelSearchForm();
                // }
                // if(tab.name == 'brandList'){
                //     // 触发‘配置管理’事件
                //     this.pageparm.currentPage =1;
                //     this.submitBrandSearchForm();
                // }


            },

        }
    }

</script>

<style type="less" scoped>
  /deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/carManager.vue